import React, { FC } from "react";
// import { Link } from "gatsby";
import { Link } from "gatsby-theme-material-ui";

import { Colors } from "@theme/colors";
import { MenuLink } from "@src/types";
import { uiContainerTransitionMs, uiOpacityHover } from "@src/utils";
import { Typography } from "@mui/material";

interface Props {
  data: MenuLink;
  level: number;
}

const linkStyle = {
  color: `${Colors.PrimaryContrast} !important`,
  fontSize: "15px",
  fontWeight: "400",
  lineHeight: "26px",
  fontFamily: "Inter",
  letterSpacing: "-0.25px",
  textDecoration: "none",
  opacity: 1,
  transition: `opacity ${uiContainerTransitionMs}ms ease-in-out`,
  "&:hover": {
    opacity: uiOpacityHover,
  },
};

const disabledStyle = {
  color: Colors.BodyText,
  fontSize: "14px",
  fontWeight: "300",
  lineHeight: "32px",
  fontFamily: "Inter",
  textDecoration: "none",
};

export const FooterLink: FC<Props> = ({ data, level = 0 }) => {
  if (data.type === "external") {
    return (
      <Typography sx={linkStyle}>
        <a
          href={data.link}
          target="_blank"
          style={linkStyle}
          key={`link-${data.name}`}
        >
          {data.name}
        </a>
      </Typography>
    );
  } else if (data.type === "disabled") {
    return (
      <span style={disabledStyle} key={`link-${data.name}`}>
        {data.name}
      </span>
    );
  }

  // default - return internal link
  return (
    <Link
      to={data.link}
      sx={linkStyle}
      key={`link-${data.name}`}
      color={Colors.PrimaryContrast}
    >
      {data.name} {data?.tag && data?.tag.trim() !== "" ? `(${data.tag})` : ""}
    </Link>
  );
};

export default FooterLink;
